export interface RecaptchaResponse {
  token: string | null;
  context: {
    userAgent: string;
    action: string;
  };
}

declare global {
  interface Window {
    __recaptchaWidgetId?: number;
    grecaptcha: {
      enterprise: {
        execute: (widgetId: number, options: { action: string }) => Promise<string>;
        ready: (callback: () => void) => void;
        render: (
          container: string | HTMLElement,
          parameters: {
            sitekey: string;
            size?: string;
            'error-callback'?: () => void;
          }
        ) => number;
      };
    };
  }
}

/**
 * Get a reCAPTCHA Enterprise token and context for the specified action
 * @param action The action to get a token for (default: 'LOGIN')
 * @returns A Promise that resolves to an object containing the token and context information
 */
export const getRecaptchaToken = async (action = 'LOGIN'): Promise<RecaptchaResponse> => {
  const context = {
    userAgent: navigator.userAgent,
    action: action
    // Note: userIpAddress should be added on the server side
  };

  if (!window.grecaptcha || !window.grecaptcha.enterprise || window.__recaptchaWidgetId == null) {
    console.warn('reCAPTCHA Enterprise not loaded yet');
    return { token: null, context };
  }

  try {
    const widgetId = window.__recaptchaWidgetId;
    return new Promise((resolve) => {
      window.grecaptcha.enterprise.ready(() => {
        window.grecaptcha.enterprise
          .execute(widgetId, { action })
          .then((token) => {
            if (!token) {
              console.warn('Empty token received from reCAPTCHA');
            }
            resolve({ token, context });
          })
          .catch((error) => {
            console.error('reCAPTCHA Enterprise execution error:', error);
            resolve({ token: null, context });
          });
      });
    });
  } catch (error) {
    console.error('reCAPTCHA Enterprise error:', error);
    return { token: null, context };
  }
};
